export class MongoDBObjectID {

    static MACHINE_ID = parseInt((Math.random() * 0xffffff).toString(), 10);
    static checkForHexRegExp = new RegExp('^[0-9a-fA-F]{24}$');
    static index;


    static newId() {
        let time = ~~(Date.now() / 1000);

        // Use pid
        var pid = Math.floor(Math.random() * 100000)
        var inc = MongoDBObjectID.get_inc();

        // Buffer used
        var buffer = new Uint8Array(12);

        // Encode time
        buffer[3] = time & 0xff;
        buffer[2] = (time >> 8) & 0xff;
        buffer[1] = (time >> 16) & 0xff;
        buffer[0] = (time >> 24) & 0xff;

        // Encode machine
        buffer[6] = MongoDBObjectID.MACHINE_ID & 0xff;
        buffer[5] = (MongoDBObjectID.MACHINE_ID >> 8) & 0xff;
        buffer[4] = (MongoDBObjectID.MACHINE_ID >> 16) & 0xff;

        // Encode pid
        buffer[8] = pid & 0xff;
        buffer[7] = (pid >> 8) & 0xff;

        // Encode index
        buffer[11] = inc & 0xff;
        buffer[10] = (inc >> 8) & 0xff;
        buffer[9] = (inc >> 16) & 0xff;

        // Return the id as a hex string
        return MongoDBObjectID.toHexString(buffer);
    }

    static isValid(id) {
        if (id && typeof id === 'string') {
            return id.length === 12 || (id.length === 24 && MongoDBObjectID.checkForHexRegExp.test(id));
        } else {
            return false;
        }
    }

    static buf2hex(buffer) { // buffer is an ArrayBuffer
        return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('');
    }

    static toHexString(buffer) {
        if (buffer instanceof Uint8Array) {
            return MongoDBObjectID.buf2hex(buffer);
        }
        return null;
    }

    static getIndex() {
        return ~~(Math.random() * 0xffffff);
    }

    static get_inc() {
        return (MongoDBObjectID.index = (MongoDBObjectID.getIndex() + 1) % 0xffffff);
    }
}